import { PAGE_PATH_GUEST_ORDER_DETAIL } from '@bluheadless/ui-logic/src/constants'
import { NoSsr } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'
import ArrowheadRightIcon from '../../../atoms/icons/arrowhead-right-icon'
import Typography from '../../../atoms/typography'
import Link from '../../../molecules/link'
import Table from '../../../molecules/table'
import { ButtonStyled, Root } from './order-table.styled'

const OrderTable = ({ orders }) => {
	const { formatMessage } = useIntl()
	const transformOrder = (orders) =>
		orders?.map(({ orderId, orderNumber, email }) => ({
			id: orderId,
			number: (
				<Typography variant="body2" color="primary" component="span">
					{orderNumber}
				</Typography>
			),
			email: (
				<Typography variant="body2" color="primary" component="span">
					{email}
				</Typography>
			),
			action: (
				<ButtonStyled
					component={Link}
					variant="icon"
					Icon={ArrowheadRightIcon}
					color="primary"
					href={PAGE_PATH_GUEST_ORDER_DETAIL + orderNumber}
				/>
			),
		}))

	return (
		<NoSsr>
			{orders.length ? (
				<Root className="GuestOrder-root">
					<Typography variant="h4">
						<FormattedMessage id="guest_order_table_title" />
					</Typography>
					<Table
						enablePagination={false}
						headers={[
							{
								content: formatMessage({ id: 'table_order_title' }) + ' #',
								id: 'number',
							},
							{
								content: formatMessage({ id: 'forms_email_label_default' }),
								id: 'email',
							},
							{
								content: '',
								id: 'action',
							},
						]}
						rows={transformOrder(orders)}
						rowsCount={orders.length}
						rowsPerPage={orders.length}
						rowsPerPageOptions={[]}
						showInnerHeaders={true}
						defaultSortBy={{
							by: 'number',
							direction: 'desc',
						}}
					/>
				</Root>
			) : null}
		</NoSsr>
	)
}

export default OrderTable
